var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.0007 3.00439C60.0689 3.00439 76.3627 19.2982 76.3627 39.3664C76.3627 59.4346 60.0689 75.7284 40.0007 75.7284C19.9325 75.7284 3.63867 59.4346 3.63867 39.3664C3.63867 19.2982 19.9325 3.00439 40.0007 3.00439Z",
    fill: "#1ACC81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 11.9312C55.2634 11.9312 67.6562 24.3239 67.6562 39.5874C67.6562 54.8508 55.2634 67.2436 40 67.2436C24.7365 67.2436 12.3438 54.8508 12.3438 39.5874C12.3438 24.3239 24.7365 11.9312 40 11.9312Z",
    fill: "#1ACC81"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1094 40.7031L35.1562 48.5938L51.4062 31.7969",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0b71975a.svg";
export { ForwardRef as ReactComponent };